const INLINE_EDITABLE_TYPES = Object.freeze({
  singleline: ['text', 'short_text'],
  multiline: ['textarea', 'long_text', 'basic_html', 'rich_text', 'rich_html'],
});

const TOOLBAR_BUTTONS = Object.freeze({
  singleline: ['bold', 'italic', 'insertLink'],
  multiline_heading: ['bold', 'italic', 'insertLink'],
  multiline: [
    'bold',
    'italic',
    'underline',
    'insertLink',
    'formatOL',
    'formatUL',
  ],
});

export function isSinglelineInlineEditableType(type) {
  return INLINE_EDITABLE_TYPES.singleline.includes(type);
}

export function isMultilineInlineEditableType(type) {
  return INLINE_EDITABLE_TYPES.multiline.includes(type);
}

export function isInlineEditableType(type) {
  return (
    isSinglelineInlineEditableType(type) || isMultilineInlineEditableType(type)
  );
}

export function getToolbarButtons(type) {
  if (isSinglelineInlineEditableType(type)) {
    return TOOLBAR_BUTTONS.singleline;
  }

  switch (type) {
    case 'rich_text':
      return TOOLBAR_BUTTONS.multiline_heading;
    default:
      return TOOLBAR_BUTTONS.multiline;
  }
}
